import { render, staticRenderFns } from "./upLoads.vue?vue&type=template&id=0b957ebd&scoped=true&"
import script from "./upLoads.vue?vue&type=script&lang=js&"
export * from "./upLoads.vue?vue&type=script&lang=js&"
import style0 from "./upLoads.vue?vue&type=style&index=0&id=0b957ebd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b957ebd",
  null
  
)

export default component.exports